/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {
  Footer_logo,
  White_envelope,
  White_phone,
} from "../../../helper/imageConstant";
import { NavLink } from "react-router-dom";

const Footer = ({ id }) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <>
      <footer
        id={id}
        className={`bg-[#A5302E] p-4 lg:p-8 mt-10 border-t-[#D1ABAB] border border-transparent footer-texture`}
      >
        <div className="mx-auto w-full max-w-screen-lg 4xl:max-w-screen-xl">
          <div className="sm:flex sm:justify-between gap-4">
            <div className="mt-4 mb-10 lg:my-0 md:mb-0 w-full sm:w-1/3 md:w-2/4 lg:w-2/4 flex lg:justify-center lg:items-center">
              <span className="text-[#fff] text-2xl md:text-4xl lg:text-[36px] 3xl:text-5xl leading-relaxed md:leading-relaxed lg:leading-normal 2xl:leading-snug 3xl:leading-tight font-normal lg:pr-[4.5rem] 3xl:pr-16 ">
                Unlock Creativity, Embrace Elegance: Transforming Visions with
                Our Premium {""}
                <span className="bg-[#fff] text-[#A5302E] px-1.5">Fabrics</span>
              </span>
            </div>
            <div className="p-2 grid grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 xl:gap-16 break-word">
              <div>
                <h2 className="mb-6 text-xl font-medium text-[#fff] underline">
                  Our Policies
                </h2>
                <ul className="font-normal text-[#fff] xl:text-sm 3xl:text-base leading-normal">
                  <li className="mb-4">
                    <NavLink
                      to="/privacy-policy"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Privacy Policy
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/shipping-policy"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Shipping Policy
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/return-policy"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Return Policy
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/terms-and-conditions"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Terms Conditions
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/delivery"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Delivery
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/disclaimer"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Disclaimers
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="mb-6 text-xl font-medium text-[#fff] underline">
                  Know us{" "}
                </h2>
                <ul className="font-normal text-[#fff] xl:text-sm 3xl:text-base">
                  <li className="mb-4">
                    <NavLink
                      to="/about-us"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      About us
                    </NavLink>
                  </li>
                  <li className="mb-4">
                    <NavLink
                      to="/contact-us"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      Contact us
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/"
                      onClick={() => scrollToTop()}
                      className="hover:underline"
                    >
                      FAQs
                    </NavLink>
                  </li>
                  <li className="mt-8 lg:hidden">
                    <img src={Footer_logo} alt="" className="max-w-full" />
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="mb-6 text-xl font-medium text-[#fff] underline">
                  Say Hello
                </h2>
                <ul className="font-normal fonts text-[#fff] xl:text-sm 3xl:text-base">
                  <li className="w-full mb-4 pb-4 border-b border-b-[#fff] flex gap-2">
                    <img src={White_envelope} alt="" className="" />
                    <div className="hover:underline">
                      info@vikasfashion.com{" "}
                    </div>
                  </li>
                  <li className="w-full flex flex-col justify-start items-center gap-2 ">
                    <div className=" flex justify-between items-center gap-2">
                      <div className="w-5">
                        <img src={White_phone} alt="White_phone" className="" />
                      </div>
                      <div className="w-full hover:underline">
                        +91 261 2320920{" "}
                      </div>
                    </div>
                    <div className=" flex justify-between items-center gap-2">
                      <div className="w-5">
                        <img src={White_phone} alt="White_phone" className="" />
                      </div>
                      <div className="w-full hover:underline">
                        +91 261 3250920
                      </div>
                    </div>
                  </li>
                  <li className="mt-8 hidden lg:block">
                    <img
                      src={Footer_logo}
                      alt="Footer_logo"
                      className="max-w-full"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr className="my-6 border-[#fff] sm:mx-auto lg:my-8" />
          <div className="flex items-center justify-center">
            <span className="text-base text-center text-[#fff]">
              © Copyright 2024{" "}
              <NavLink
                to={"https://vikasfashion.com/"}
                onClick={scrollToTop}
                className="cursor-pointer"
              >
                {" "}
                vikasfashion.
              </NavLink>{" "}
              All rights reserved.
            </span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
